import { type FC } from "react";
import { Grid } from "semantic-ui-react";

import { type EnablePackModaWithFormProps } from "./types";
import { LicensesCountField } from "./fields";
import { Link } from "./Link";

import styles from "./requestOrEnablePackForm.module.scss";

const termsOfServicesUrl = envtConfig.termsOfServicesUrl;

export const AddPackForm: FC<EnablePackModaWithFormProps> = (props) => {
  const { unlimitedLicenses } = props;

  const getPackAgreementInfo = () => {
    return (
      <div className={styles.agreement}>
        {unlimitedLicenses ? (
          <p>
            You are adding a free pack to your account. Usage is subject to the{" "}
            <Link to={termsOfServicesUrl} text="terms and conditions" />.
          </p>
        ) : (
          <p>
            <Link to={termsOfServicesUrl} text="Terms and conditions apply" />
          </p>
        )}
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <Grid stackable rows="equal" verticalAlign="bottom">
        {!unlimitedLicenses && <LicensesCountField {...props} />}
        {getPackAgreementInfo()}
      </Grid>
    </div>
  );
};

export default AddPackForm;
